import * as React from "react";
import WorkDetails, { WorkDetailsProps } from "~/components/work-details/work-details";

export interface WorkDetailsViewProps {
    contextModel: WorkDetailsProps;
}

class WorkDetailsView extends React.PureComponent<WorkDetailsViewProps> {
    public render() {
        return <WorkDetails {...this.props.contextModel} />;
    }
}

export default WorkDetailsView;
